
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class TyServer extends Vue {
  render() {
    return (
      <div class="ty-server">
        <h2 class="title">雷拓尔菲服务</h2>
        <div style="height:20px;"></div>
        <div class="ty">
          <img
            class="cleaning"
            src={require("@/assets/bjy.jpg")}
            slot="cover"
          />
          <div class="clean-dec">
            <div>
              <div>房屋保洁</div>
              <div>“干净”不止一点点</div>
            </div>
          </div>
          <div class="complement">
            <img src={require("@/assets/clean-house.jpg")} slot="cover" />
          </div>
        </div>
        <div class="ty">
          <div class="clean-dec">
            <div>
              <div>房屋维修</div>
              <div>优质又及时服务是宗旨</div>
            </div>
          </div>
          <img
            class="cleaning"
            src={require("@/assets/type-zz.jpg")}
            slot="cover"
          />
          <div class="complement">
            <div class="complement-content">
              <h3>雷拓尔菲服务</h3>
              <p>用我们的努力解决你的烦恼</p>
              <p>
                北京雷拓尔菲科技有限公司于2011年09月20日在朝阳分局登记成立。法定代表人雷乃贵，公司经营范围包括从事房地产经纪业务；房地产信息咨询；设计等。
                北京雷拓尔菲科技有限公司于2011年09月20日在朝阳分局登记成立。法定代表人雷乃贵，公司经营范围包括从事房地产经纪业务；房地产信息咨询；设计等。
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
